import IconTemplate from '../IconTemplate';
export default IconTemplate('M7 10l5 5 5-5z');